import { cn } from "../lib/cn";

// Horizontales Logo als Inline-SVG für die Startseite (Entscheidung 41).
// Geometrie 1:1 aus brand/logo/svg/ortura-logo.svg (Raster 100 × 100, siehe
// brand/README.md); nicht von Hand ändern, Quelle der Wahrheit bleibt brand/.
//
// Warum inline statt <img>: Nur so lassen sich Ring, Punkt und Wortmarke
// einzeln animieren (Klassen intro-* in styles.css), und die Wortmarke nutzt
// die geladene Manrope. Ring und Schrift folgen per currentColor der
// Textfarbe (Papier im dunklen, Nacht im hellen Thema), der Punkt ist immer Himmel.
export function LogoIntro({ className }: { className?: string }) {
  return (
    <svg
      viewBox="15.5 14 270.5 70.5"
      role="img"
      aria-label="Ortura"
      className={cn("h-auto text-ink", className)}
    >
      <path
        className="intro-ring"
        // pathLength normiert die Länge auf 100, damit die Animation nicht
        // von der echten Pfadlänge abhängt.
        pathLength={100}
        d="M79.23 43.25A30 30 0 1 1 56.75 20.77"
        fill="none"
        stroke="currentColor"
        strokeWidth={9}
        strokeLinecap="round"
      />
      <circle className="intro-dot" cx={79} cy={21} r={7} fill="var(--ortura-himmel)" />
      <text
        className="intro-word"
        x={105.75}
        y={67.25}
        fontFamily="var(--ortura-font)"
        fontWeight={600}
        fontSize={64}
        letterSpacing={-1.28}
        fill="currentColor"
      >
        ortura
      </text>
    </svg>
  );
}
